// extracted by mini-css-extract-plugin
export default {"detachedWidgetsDropOverlay":"styles_detachedWidgetsDropOverlay__HReFU","detachedWidgetsDropOverlayContent":"styles_detachedWidgetsDropOverlayContent__2aH48"};